import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { localeFormatted, configuratorType } from '../../i18n.js';

const ProductTile = ({ data }) => (
  <div className="product-tile">
    <div className="product-tile__head">
      <span className="product-tile__headline" dangerouslySetInnerHTML={{ __html: data.headline ? data.headline : '' }} />
    </div>
    <div className="product-tile__image" style={{ backgroundImage: `url(${data.imageSmall})` }} />
    <div className="product-tile__body">
      <div className="product-tile__description" ><span dangerouslySetInnerHTML={{ __html: data.subheadline }} /><br /><FormattedMessage id="results.product.number" values={{ number: data.textblock_1st_text }} />
      </div>
      <a className="product-tile__link" target="_blank" href={data.links[0].deeplink}><FormattedMessage id="results.product.button.productInformation" /></a>      
    </div>

    {configuratorType === 'shower' &&
      <a className="btn btn-block btn-primary button button--result " href="javascript:void(0);" onClick={() => this.onClickDownload()}><FormattedMessage id="results.product.button.downloadPDF" /></a>
    }
    {configuratorType === 'water' &&
      <div></div>   
    } 
    </div>
);

ProductTile.propTypes = {
  data: PropTypes.object.isRequired,
};

export default ProductTile;



// WEBPACK FOOTER //
// ./src/components/product/ProductTile.js